var _circle, _circle2, _g, _path, _g2, _rect, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 144,
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    fill: "#F1F4F9"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_25079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 144,
    height: 144
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 72,
    r: 72,
    fill: "#F1F4F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_25079)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_122_25079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 60.8155C23.0625 58.9153 25.5779 57.375 28.6809 57.375H117.569C120.672 57.375 123.188 58.9153 123.188 60.8155V115.247C123.188 117.147 120.672 118.687 117.569 118.687H28.6809C25.5779 118.687 23.0625 117.147 23.0625 115.247V60.8155Z",
    fill: "white"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 57.375H120.375V78.125C120.375 80.3341 118.584 82.125 116.375 82.125H29.875C27.6659 82.125 25.875 80.3341 25.875 78.125V57.375Z",
    fill: "url(#paint0_linear_122_25079)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_25079)",
    filter: "url(#filter1_d_122_25079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.062 107.5L109.312 109.125L110.562 108.875C111.688 107.833 113.963 105.725 114.062 105.625C114.162 105.525 114.521 104.583 114.688 104.125C114.312 103.625 113.537 102.6 113.438 102.5C113.312 102.375 109.562 105.625 109.312 105.75C109.112 105.85 108.729 105.292 108.562 105L106.938 105.25L107.062 107.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.031 105.75L116.43 103.919L116.653 101.497L114.284 100.959L113.044 98.8594L110.812 99.8175L108.581 98.8594L107.341 100.953L104.972 101.484L105.195 103.912L103.594 105.75L105.195 107.581L104.972 110.009L107.341 110.547L108.581 112.641L110.812 111.676L113.044 112.634L114.284 110.541L116.653 110.002L116.43 107.581L118.031 105.75ZM109.093 108.382L107.531 106.807C107.275 106.551 107.275 106.137 107.531 105.881L107.577 105.835C107.833 105.579 108.253 105.579 108.509 105.835L109.566 106.898L112.945 103.512C113.201 103.256 113.621 103.256 113.877 103.512L113.923 103.558C114.179 103.814 114.179 104.227 113.923 104.483L110.038 108.382C109.769 108.638 109.356 108.638 109.093 108.382Z",
    fill: "#2FC5D2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_122_25079",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 17,
    width: 96,
    height: 66
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.875,
    y: 17.4375,
    width: 94.5,
    height: 64.6875,
    fill: "#C4C4C4"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_122_25079)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4062 84.9375L34.3125 55.125L93.9375 55.125L64.4062 84.9375Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0938 46.5938H38.7188C35.1867 46.5938 32.329 49.4836 32.329 53.0156L32.2969 91.5469C32.2969 95.0789 35.1867 97.9687 38.7188 97.9687H90.0938C93.6258 97.9687 96.5156 95.0789 96.5156 91.5469V53.0156C96.5156 49.4836 93.6258 46.5938 90.0938 46.5938ZM88.8094 60.2402L66.108 74.4326C65.0805 75.0748 63.732 75.0748 62.7045 74.4326L40.0031 60.2402C39.2004 59.7265 38.7188 58.8595 38.7188 57.9284C38.7188 55.777 41.0627 54.4927 42.893 55.6165L64.4063 69.0703L85.9195 55.6165C87.7498 54.4927 90.0938 55.777 90.0938 57.9284C90.0938 58.8595 89.6121 59.7265 88.8094 60.2402Z",
    fill: "#052449"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_122_25079",
    x: -1.9375,
    y: 42.375,
    width: 150.125,
    height: 111.312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_25079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_25079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_122_25079",
    x: 99.5775,
    y: 94.515,
    width: 22.47,
    height: 22.47,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.68
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_25079"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_25079",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_122_25079",
    x1: 73.125,
    y1: 57.375,
    x2: 73.125,
    y2: 82.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711458,
    stopColor: "#E0E0E0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_25079"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 15.75,
    fill: "white",
    transform: "translate(102.938 97.875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/Messages.c6178bc4.svg";
export { ForwardRef as ReactComponent };